<div class="checkbox-container">
  <div class="checkbox-container__box">
    <p-checkbox [value]="value" [binary]="true" [(ngModel)]="value" (ngModelChange)="valueChange.emit($event)"></p-checkbox>
  </div>
  <div class="checkbox-container__text" (click)="value = !value" (mouseenter)="isHovered = true" (mouseleave)="isHovered = false">
    <ng-content></ng-content>
  </div>
</div>
